import { QuestionPreviewType } from "mobx-store/storeInterfaces/surveyInterface";
import { FacilityDTO } from "./staticTextDTO";
import { FacilityFormViewModel } from "./staticTextFormViewModel";

const facilityToDTO = (formViewModel: FacilityFormViewModel): FacilityDTO => {
  const {
    key,
    app,
    category,
    value,
    description,
    languageCode,

  } = formViewModel;
  return {
    key,
    app,
    category,
    value,
    description,
    languageCode,
  };
}

export {
  facilityToDTO,
}